<template>
  <!-- 内容区域 -->
  <div class="page-content" style="padding: 0">
    <!-- 标签页 -->
    <el-tabs v-model="activeTab">
      <!-- 轮播图广告标签页 -->
      <el-tab-pane label="轮播图广告" name="carouselAd">
        <keep-alive>
          <CarouselAdTab v-if="activeTab === 'carouselAd'" />
        </keep-alive>
      </el-tab-pane>
      <!-- 首页悬浮图标标签页 -->
      <el-tab-pane label="首页悬浮图标" name="floatingIcon">
        <keep-alive>
          <FloatingIconTab v-if="activeTab === 'floatingIcon'" />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CarouselAdTab from './components/CarouselAdTab.vue'
import FloatingIconTab from './components/FloatingIconTab.vue'

export default {
  name: 'AdManage',
  components: {
    CarouselAdTab,
    FloatingIconTab,
  },
  data() {
    return {
      // 当前激活的标签页
      activeTab: 'carouselAd',
    }
  },
}
</script>

<style scoped>
.page-content {
  padding: 0;
}

.page-content :deep(.el-tabs__item) {
  padding: 0 20px !important;
}
</style>
